module.exports = __webpack_public_path__ + "static/media/md-calculator.c6ca35a8.svg";